import { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import AddClubHeader from "../../components/Headers/AddClubHeader.js";
import helper from "../../services/helper.service";
import adminApi from "../../services/admin.service";

function Facilities() {
  const [facilities, setFacilities] = useState([]);
  const [clubs, setClubs] = useState([]);
  const [newFacility, setNewFacility] = useState({ name: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchFacilities();
    fetchClubs();
  }, []);

  const fetchFacilities = () => {
    adminApi.getFacilities().then((response) => {
      if (response.status === 200) {
        setFacilities(response.data);
      } else {
        helper.showToast("Error", "Failed to fetch facilities.", 3);
      }
    });
  };

  const fetchClubs = () => {
    adminApi.getClubList().then((response) => {
      if (response.status === 200) {
        setClubs(response.data.sort((a, b) => a.name.localeCompare(b.name)));
      }
    });
  };

  const onCreateFacility = () => {
    if (!newFacility.name.trim()) {
      helper.showToast("Error", "Facility name is required.", 3);
      return;
    }
    adminApi.createFacility({ name: newFacility.name.trim() }).then((response) => {
      if (response.status === 200) {
        helper.showToast("Success", "Facility created successfully.", 1);
        setNewFacility({ name: "" });
        setIsModalOpen(false);
        fetchFacilities();
      } else {
        helper.showToast("Error", response.message || "Failed to create facility.", 3);
      }
    });
  };

  const coursesForFacility = (facilityId) =>
    clubs
      .filter((c) => c.facility_id === facilityId)
      .map((c) => c.name)
      .join(", ") || "—";

  return (
    <>
      <AddClubHeader />
      <Container className="mt--9" fluid>
        <Row>
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0 d-flex justify-content-between align-items-center">
                <div>
                  <h3 className="text-white mb-0">Facilities</h3>
                  <small className="text-muted">
                    Assign a course to a facility from the Add / Edit Club screen.
                  </small>
                </div>
                <Button color="primary" onClick={() => setIsModalOpen(true)}>
                  Add Facility
                </Button>
              </CardHeader>
              <Table className="align-items-center table-dark table-flush" responsive>
                <thead className="thead-dark">
                  <tr>
                    <th>Name</th>
                    <th>Courses</th>
                  </tr>
                </thead>
                <tbody>
                  {facilities.map((facility, index) => (
                    <tr key={facility.id ?? index}>
                      <td>{facility.name}</td>
                      <td>{coursesForFacility(facility.id)}</td>
                    </tr>
                  ))}
                  {facilities.length === 0 && (
                    <tr>
                      <td colSpan="2">No facilities yet. Click "Add Facility" to create one.</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>

      {/* Add Facility modal */}
      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(!isModalOpen)}>
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>Add New Facility</ModalHeader>
        <ModalBody>
          <Form>
            <Input
              placeholder="Facility Name (e.g. Daniel Island Club - SC)"
              value={newFacility.name}
              onChange={(e) => setNewFacility({ name: e.target.value })}
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onCreateFacility}>
            Create
          </Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Facilities;
